import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';
import { useUIStore } from '../../store';

export function Toast() {
  const { toast, hideToast } = useUIStore();

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(hideToast, 5000);
      return () => clearTimeout(timer);
    }
  }, [toast, hideToast]);

  if (!toast) return null;

  const icons = {
    success: <CheckCircle2 className="text-emerald-400" size={20} />,
    error: <XCircle className="text-rose-400" size={20} />,
    info: <Info className="text-indigo-400" size={20} />,
  };

  const styles = {
    success: 'border-emerald-500/30',
    error: 'border-rose-500/30',
    info: 'border-indigo-500/30',
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-slide-up">
      <div
        className={clsx(
          'glass-card rounded-xl px-4 py-3 flex items-center gap-3 border',
          styles[toast.type]
        )}
      >
        {icons[toast.type]}
        <span className="text-sm font-medium">{toast.message}</span>
        <button
          onClick={hideToast}
          className="ml-2 text-white/40 hover:text-white transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
